import React from 'react'
import BaseIcon from 'react-icon-base'

const SE = props => (
  <BaseIcon width="21" height="15" viewBox="0 0 21 15" {...props}>
    <title>SE</title>
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#006AA7"
        d="M19.5,15H1.5C0.7,15,0,14.3,0,13.5V1.5C0,0.7,0.7,0,1.5,0h17.9C20.3,0,21,0.7,21,1.5v11.9
		C21,14.3,20.3,15,19.5,15z"
      />
      <defs>
        <filter id="Adobe_OpacityMaskFilter" filterUnits="userSpaceOnUse" x="0" y="0" width="21" height="15">
          <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
        </filter>
      </defs>
      <mask
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="21"
        height="15"
        id="b_00000145056428693758705080000012067637698345754543_"
      >
        <g filter="url(#Adobe_OpacityMaskFilter)">
          <path
            id="a_00000182511617701184927790000000703482997425936309_"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#FFFFFF"
            d="M2,0h17c1.1,0,2,0.9,2,2v11c0,1.1-0.9,2-2,2H2
				c-1.1,0-2-0.9-2-2V2C0,0.9,0.9,0,2,0z"
          />
        </g>
      </mask>
      <path
        mask="url(#b_00000145056428693758705080000012067637698345754543_)"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FECC00"
        d="M6,0h3v6h12v3H9v6H6V9H0V6h6V0z"
      />
      <g>
        <path
          id="c"
          fill="none"
          stroke="#2F343A"
          strokeOpacity="0.157"
          d="M1.5,0.5h18c0.6,0,1,0.4,1,1v12c0,0.6-0.4,1-1,1h-18c-0.6,0-1-0.4-1-1v-12C0.5,0.9,0.9,0.5,1.5,0.5z"
        />
      </g>
    </g>
  </BaseIcon>
)

export default SE
